import React from 'react';
import {
    Modal,
    TextInput,
    Button,
    Grid,
    LoadingOverlay,
    Paper,
    Title,
    Group,
    Avatar,
    Text,
    Stack,
} from '@mantine/core';
import { IconUser, IconCheck } from '@tabler/icons-react';

interface CreateStudentProps {
    opened: boolean;
    onClose: () => void;
    loading: boolean;
    studentData: {
        student_id: string;
        name: string;
        email: string;
        mobile: string;
        enrollDate: string;
    };
    onStudentChange: (field: string, value: string) => void;
    onSubmit: () => void;
}

const CreateStudent: React.FC<CreateStudentProps> = ({
    opened,
    onClose,
    loading,
    studentData,
    onStudentChange,
    onSubmit,
}) => {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={
                <Group gap="sm">
                    <Avatar size="sm" radius="xl" color="blue" variant="light">
                        <IconUser size={16} />
                    </Avatar>
                    <Title order={3}>Create New Student</Title>
                </Group>
            }
            size="lg"
            padding="xl"
            radius="md"
            shadow="xl"
        >
            <LoadingOverlay visible={loading} />

            <Stack gap="md">
                <Paper p="md" radius="md" withBorder>
                    <Grid gutter="md">
                        <Grid.Col span={6}>
                            <TextInput
                                label="Student ID"
                                value={studentData.student_id}
                                readOnly
                                styles={{
                                    input: {
                                        backgroundColor: '#f8fafc',
                                        borderColor: '#e2e8f0',
                                    },
                                }}
                            />
                        </Grid.Col>
                        <Grid.Col span={6}>
                            <TextInput
                                label="Name"
                                placeholder="Enter student name"
                                value={studentData.name}
                                onChange={(e) => onStudentChange("name", e.target.value)}
                                required
                            />
                        </Grid.Col>
                        <Grid.Col span={6}>
                            <TextInput
                                label="Email"
                                placeholder="Enter student email"
                                value={studentData.email}
                                onChange={(e) => onStudentChange("email", e.target.value)}
                                required
                            />
                        </Grid.Col>
                        <Grid.Col span={6}>
                            <TextInput
                                label="Mobile"
                                placeholder="Enter mobile number"
                                value={studentData.mobile}
                                onChange={(e) => onStudentChange("mobile", e.target.value)}
                                required
                            />
                        </Grid.Col>
                        <Grid.Col span={6}>
                            <TextInput
                                label="Enroll Date"
                                type="date"
                                value={studentData.enrollDate}
                                onChange={(e) => onStudentChange("enrollDate", e.target.value)}
                                required
                            />
                        </Grid.Col>
                    </Grid>
                </Paper>

                <Group justify="flex-end" gap="md">
                    <Button
                        variant="outline"
                        color="gray"
                        onClick={onClose}
                        radius="xl"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onSubmit}
                        variant="gradient"
                        gradient={{ from: 'blue', to: 'cyan' }}
                        size="md"
                        radius="xl"
                        leftSection={<IconCheck size={16} />}
                        style={{
                            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)',
                            transition: 'all 0.2s ease',
                        }}
                        className="hover:scale-105"
                    >
                        Create Student
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
};

export default CreateStudent; 